<template>
  <!--
    The relationship between the two records, stated rather than implied. The
    spec creates two linked records from one sentence, so the link needs to be
    as visible as the records themselves.
  -->
  <div class="relative flex items-center gap-2.5 py-2 pl-8">
    <span class="absolute left-4 top-0 bottom-0 w-0.5 bg-accent-foreground/20" />
    <Link2 class="size-3.5 shrink-0 text-brand" />
    <span class="text-xs font-bold uppercase tracking-ds-wide text-accent-foreground">
      {{ label }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { Link2 } from '@lucide/vue'

defineProps<{
  label: string
}>()
</script>
